<template>
  <div id="mbti" class="home">
    <el-container>   
      <div style="margin:80px 100px;width:100%;">
        <div class="">
          <div class="intro">
            <div>测评技术服务由<span><a  style="text-decoration:none;color:#ffffff;background-color:#3CD3F6;padding:2px 4px;" target="_blank" href="http://www.wisechoices.cn">睿哲咨询(www.wisechoices.cn)</a></span>提供，如需详细了解请致电：<a href="javascript:void(0)" style="text-decoration:none;color:#ffffff;background-color:#3CD3F6;padding:2px 4px;">010-53323618 / 13810901404</a></div>            
            <div>每道题目均有两个答案:A和B.请仔细阅读题目,按照与你性格相符的程度分别给A和B赋予一个分数,并使一组中的两个分数之和为5,最高分为5，最低分为0（不选即为0）</div>
            <div style="font-size:12px;color:#999;">MBTI的全名是Myers-Briggs Type Indicator。它是一种迫选型、自我报告式的性格评估理论模型，用以衡量和描述人们在获取信息、作出决策、对待生活等方面的心理活动规律和性格类型。MBTI采用量表与自评相结合的方式揭示性格类型。要求受测者在完全解除压力的状态下选择自己最自然的做法或者反应。量表的问题都经过反复筛选和实践检验，为了取得最佳效果，量表在使用中还要遵循一套严格的程序与规范并由MBTI测试行为规范进行指导。最终，受测者结合量表计分和自评结果，自行确定自己的性格类型——MBTI相信，最清楚自己性格的当然就是你自己；如果有什么东西遮蔽了你的自知之明，那么就让MBTI来帮助你重新认识你自己。</div>            
          </div>
        </div>      
        <div class="content">
          <div class="qs-item" v-for="(item,index) in qs" :key="index">
            <div class="title">{{ index+1 }}、{{ item.title }}</div>
            <div v-for="(as,idx) in item.children" :key="idx" class="answer-box">
              <div class="answer-item">{{ as.k }}、{{ as.a }} &nbsp;&nbsp;&nbsp;&nbsp;<el-rate :value="answer[index][as.k]" @change="((val) => { handleChange(val,index,as.k) })" style="display:inline-block;" :show-text="true" :texts="texts" :colors="['#3CD3F6','#3CD3F6','#3CD3F6']"></el-rate></div>              
            </div>
          </div>
          <el-button type="primary" style="width:200px;" @click="doCheck">{{ status }}</el-button>
        </div>
        <!-- 报告类型选择弹出层 -->
        <el-dialog title="选择下载类型" :visible.sync="outerVisible" :close-on-click-modal="false" :close-on-press-escape="false">
          <div style="width:100%">
            <el-row :gutter="20">
              <el-col :span="12">
                <div :class="{'cart_n':true,'cart':true,'active':downloadType == 4}" @click="handleSelect(4)">
                  <div class="title">标准版（首次免费）</div>
                  <div class="">售价￥9.8每份</div>
                </div>              
              </el-col>
              <el-col :span="12">
                <div :class="{'cart_p':true,'cart':true,'active':downloadType == 5}" @click="handleSelect(5)">
                  <div class="title">专业版</div>
                  <div class="">售价￥19.8每份</div>
                </div>
              </el-col>
            </el-row>            
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="download" :loading="loading">确认付款购买</el-button>
          </div>
        </el-dialog>
        <!-- 报告类型选择弹出层 --> 
        <!-- 报告下载 -->
        <el-dialog title="下载报告" :visible.sync="innerVisible" :close-on-click-modal="false" :close-on-press-escape="false">
          <div>
            <el-row :gutter="20">
              <el-col :span="12">
                <div>
                  <a :href="url" target="_blank" download="测评结果文件.pdf">点击下载报告</a>
                </div>
              </el-col>              
            </el-row>            
          </div>
        </el-dialog>
        <!-- 报告下载 -->
      </div>
    </el-container>
  </div>
</template>
<script>
import { fetchGet,fetchPost } from '../utils/http';
import mbti from "../utils/MBTI"
export default {
  name:'mbti',
  data(){
    return {
      outerVisible: false,
      innerVisible: false,
      innerHTML:{},      
      status:'提交答案',
      source:'http://www.taizhicn.com',
      downloadType:4,
      url:'',
      texts:["1分","2分","3分","4分","5分",],
      loading:false,
      qs:[],
      answer:[{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},{A:0,B:0},]
    }
  },
  methods:{
    handleChange(v,i,k){
      let token = sessionStorage.getItem('token');
      if(token == undefined || token == null){
        this.$message.error('登录后才能测试，请先登录或注册用户');
        setTimeout(()=>{
          return this.$router.push('/login');
        },1000)
      }
      console.log(v,i,k);
      let newVal = {A:0,B:0};
      if(k == "A"){
        newVal.A = v;
        newVal.B = 5-v;
      }
      if(k == "B"){
        newVal.A = 5-v;
        newVal.B = v;
      }
      this.$set(this.answer,i,newVal);  
    },
    download(){
      this.loading = true;
      let _this = this;
      fetchPost('/api/home/api/downloadMBTIreport',{
        downloadType:this.downloadType,answer : this.answer,source:this.source
      }).then((res)=>{
        this.loading = false;
        if(res.data.code === 10001){
          _this.$message.error(res.data.msg);
          _this.$router.push('/login');
        }
        if(res.data.code === 10002){
          _this.$message.error(res.data.msg);
          _this.$router.push('/member-center');
        }
        if(res.data.code === 0){
          return _this.$message.error(res.data.msg);        
        }
        if(res.data.code === 1){
          if(res.data.data.status == 2000){
            var newWin = window.open("","_blank");
            newWin.document.body.innerHTML = res.data.data.form;
            newWin.document.forms[0].submit();
            return;
          }
          if(res.data.data.status == undefined){
            _this.url = res.data.data;
            _this.innerVisible = true;           
          }
        }
      });
    },
    doCheck(){
      for(let item of this.answer){
        if(item.A + item.B != 5){
          return this.$message.error('还有题目未选择，请先做完所有测试题');          
        }
      }
      this.outerVisible = true;
    },
    handleSelect(index){
      this.downloadType = index;
    },
    init(){            
      this.qs = mbti;
    }
  },
  mounted(){
    this.init();    
  }
}
</script>
<style scoped>
.home{
  background-color: #f4f4f4;
  width: 100%;
}
.content{
  background-color: #ffffff;
  padding: 50px 80px;
}
.qs-item{
  margin-bottom: 30px;
}
.title{
  font-size: 14px;
  padding-bottom: 10px;
}
.answer-item{
  font-size: 14px;
  color: #777;
  margin-bottom: 4px;
  cursor: pointer;
  padding: 8px 12px;
}
.answer-box{
  margin-left: 24px;
}
.active{
  background-color: #3CD3F6;
  color: #ffffff;
}
.intro{
  font-size: 14px;
  text-align: justify;
  color: #888;
  line-height: 2;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 30px 50px;
  margin-bottom: 20px;
}
.cart{
  width: 100%;
  height: 120px;
  background-color: #3CD3F6;
  border-radius: 10px;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.cart .title{
  padding-top: 35px;
  font-size: 14px;
  font-weight: bold;
}
.active{
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6);
  border: 1px dashed #ffffff;
}
.explain{
  margin: 50px 30px 30px 30px;  
}
</style>
